/**
 * @generated SignedSource<<e45439882e64c3c1368f2b3d7c2e28e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CheckoutPixAutomaticAddInput = {
  additionalInfo?: ReadonlyArray<CheckoutAdditionalInfo | null | undefined> | null | undefined;
  checkout?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  customer?: CustomerCheckoutPixAutomatic | null | undefined;
  value?: number | null | undefined;
};
export type CustomerCheckoutPixAutomatic = {
  address?: AddressInput | null | undefined;
  email?: string | null | undefined;
  name: string;
  phone?: string | null | undefined;
  taxID: string;
};
export type AddressInput = {
  city: string;
  complement?: string | null | undefined;
  country?: string | null | undefined;
  location?: location | null | undefined;
  neighborhood?: string | null | undefined;
  number: string;
  rawGoogleApiResponse?: string | null | undefined;
  state: string;
  street: string;
  zipcode?: string | null | undefined;
};
export type location = {
  lat?: number | null | undefined;
  lng?: number | null | undefined;
};
export type CheckoutAdditionalInfo = {
  key: string;
  value?: string | null | undefined;
};
export type CheckoutPixAutomaticAddMutation$variables = {
  input: CheckoutPixAutomaticAddInput;
};
export type CheckoutPixAutomaticAddMutation$data = {
  readonly CheckoutPixAutomaticAdd: {
    readonly error: string | null | undefined;
    readonly paymentSubscription: {
      readonly id: string;
      readonly pixRecurring: {
        readonly paymentLinkUrl: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly success: string | null | undefined;
  } | null | undefined;
};
export type CheckoutPixAutomaticAddMutation = {
  response: CheckoutPixAutomaticAddMutation$data;
  variables: CheckoutPixAutomaticAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckoutPixAutomaticAddPayload",
    "kind": "LinkedField",
    "name": "CheckoutPixAutomaticAdd",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentSubscription",
        "kind": "LinkedField",
        "name": "paymentSubscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PixRecurring",
            "kind": "LinkedField",
            "name": "pixRecurring",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentLinkUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutPixAutomaticAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckoutPixAutomaticAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4473fb3119ceba9dde0ce32c24591a3",
    "id": null,
    "metadata": {},
    "name": "CheckoutPixAutomaticAddMutation",
    "operationKind": "mutation",
    "text": "mutation CheckoutPixAutomaticAddMutation(\n  $input: CheckoutPixAutomaticAddInput!\n) {\n  CheckoutPixAutomaticAdd(input: $input) {\n    paymentSubscription {\n      id\n      pixRecurring {\n        paymentLinkUrl\n      }\n    }\n    error\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "16a7a2c6365d8e9668bb7e15f9b9adde";

export default node;
